import CirclesWithBar from 'react-loader-spinner/dist/loader/CirclesWithBar'
import FormGroup from '../components/FormGroup'
import Input from '../components/Input'
import Select from '../components/Select'
import Title from '../components/Title'
import { useAbiEncoder } from '../hooks'
import ParametersSection from '../sections/ParametersSection'
import ParseSection from '../sections/ParseSection'
import { FetchUris } from '../utils/constants'
function Home() {
    const {
        networkUri,
        contractAddress,
        abi,
        encoded,
        onChange,
        onParse,
        onClear,
        parseError,
        parameters,
        abiFunctions,
        encodeErrors,
        fetchApi,
        contractDatas,
        loading,
        onHandleParse,
    } = useAbiEncoder()
    return (
        <>
            {loading && (
                <div className="loading-overlay">
                    <CirclesWithBar
                        height="100"
                        width="100"
                        color="#4fa94d"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        outerCircleColor=""
                        innerCircleColor=""
                        barColor=""
                        ariaLabel="circles-with-bar-loading"
                    />
                </div>
            )}
            <div className="container">
                <Title />
            </div>
            <div className="container">
                {/* <div className="input-field parse-input">
                    <Input
                        className="method-input__value"
                        onChange={onChange('provider')}
                        value={networkUri}
                        placeholder="Provider uri"
                        type="text"
                        name="listen"
                    />
                </div> */}

                <div className="method-input__value input-field parse-input">
                    <FormGroup label={'Fetch Uri'}>
                        <Select
                            onChange={onChange('fetchApi')}
                            value={fetchApi}
                            options={FetchUris}
                        />
                    </FormGroup>
                </div>

                <div className="method-input__value input-field parse-input">
                    <FormGroup label={'Contract addresses'}>
                        <Select
                            onChange={onChange('selectContract')}
                            value={contractAddress}
                            options={contractDatas}
                        />
                    </FormGroup>
                </div>

                <div className="input-field parse-input">
                    <Input
                        className="method-input__value"
                        onChange={onChange('scAddress')}
                        value={contractAddress}
                        placeholder="Contract address (*)"
                        type="text"
                        name="listen"
                    />
                </div>
            </div>

            <ParseSection
                onChange={onChange('abi')}
                value={abi}
                onParse={onParse}
                onClear={onClear}
                parseError={parseError}
                onHandleParse={onHandleParse}
            />
            <ParametersSection
                onChange={onChange('parameters')}
                value={parameters}
                abiFunctions={abiFunctions}
                errors={encodeErrors}
                networkProvider={networkUri}
                scAddress={contractAddress}
            />
            <div className="container">
                <p>
                    ABI itself is the description of the code interface. It’s a way for the
                    contracts to interact within an ecosystem as well as contract-to-contract.
                </p>
                <p>
                    Smart contract ABI parsing is required for verifying the contract on Etherscan
                    or making a transaction to call a method. For most actions regarding this code,
                    you would require a special tool, and the arguments have to be encoded in a
                    specific way. HashEx tool does it automatically, free, and doesn’t involve
                    downloading any extra applications.
                </p>
                <p>
                    Code itself is used in the byte format, so it’s harder to decode it correctly.
                    For easy interactions with said code, HashEx has created its ABI decoder. An
                    additional tool allows you to manually enter the values for the parameters.
                </p>
            </div>
        </>
    )
}

export default Home
